export const TITLE = 'Site Builder';
export const NAV_SECTIONS_LABEL = 'Sections';
export const NAV_PREVIEW_LABEL = 'Preview';
